
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_STORIES').plugin(axiosPlugin, {template: "array"});

let fetchHomeStoriesAction = redux.fetchActionGet();

export const fetchHomeStories = () => fetchHomeStoriesAction(`/features/stories`);

export const homeStories = redux.reducer();